import { RiHistoryFill } from "react-icons/ri";
import { MdAccountTree, MdDevices, MdOutlineDevices, MdOutlinePassword } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import { BsBuildings } from "react-icons/bs";
import { FcInvite } from "react-icons/fc";
import { ImProfile } from "react-icons/im";
import { TbAuth2Fa } from "react-icons/tb";
import { BiError } from "react-icons/bi";

/* -------------------- MENU CONFIG -------------------- */

const Admin_SECTIONS = [
  {
    title: "Member Management",
    items: [
      { key: "userManagement", label: "User Management", icon: <FiUsers /> },
      { key: "designationManagement", label: "Designation Management", icon: <BsBuildings /> },
      { key: "invitationManagement", label: "Invitation Management", icon: <FcInvite />  },
    ],
  },
  {
    title: "Account Management",
    items: [
      { key: "setupAccount", label: "Manage Account", icon: <MdAccountTree /> },
      { key: "manageProfile", label: "Manage Profile", icon: <ImProfile /> },
      { key: "changePassword", label: "Change Password", icon: <MdOutlinePassword /> },
      { key: "twoFactorAuthentication", label: "2 Factor Authentication", icon: <TbAuth2Fa /> },
      { key: "setupAnotherDevices", label: "Setup Another Devices", icon: <MdOutlineDevices /> },
      { key: "linkedDevices", label: "Linked Devices", icon: <MdDevices /> },
      { key: "loginHistory", label: "Login History", icon: <RiHistoryFill /> },
      { key: "bruteforceAttack", label: "Brute Force Attack", icon: <BiError /> },
    ],
  },
];

/* -------------------- COMPONENT -------------------- */

const AccountSidebar = ({ openAdminModules, setOpenAdminModules }) => {

  return (
    <>
      {/* Sidebar Menu */}
      <div className="overflow-auto" style={{ height: "calc(100vh - 55px)" }}>
        {Admin_SECTIONS.map((section) => (
          <div className="channels-section mb-3" key={section.title}>
            <div className="section-title px-2 fw-bold">
              <span>{section.title}</span>
            </div>

            <div className="px-2">
              {section.items.map((item) => (
                <div
                  key={item.key}
                  className={`channel-item mb-1 ${
                    openAdminModules === item.key ? "active" : ""
                  }`}
                  title={item.label}
                  onClick={() => setOpenAdminModules(item.key)}
                >
                  <div className="hstack gap-2">
                    {item.icon}
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AccountSidebar;
